import { shallowMount } from "@vue/test-utils";
import DatosPersonales from "@/views/DatosPersonales";

describe("DatosPersonales component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(DatosPersonales);
  });

  it("Renders del component DatosPersonales", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
